import { setting, sysStatus } from '../musicbox-action/index';
import { bc500SysStatus, bc500Setting } from '../bc500-action/index';
import { rg05Setting, rg05NuclideSetting } from '../rg05-action/index';
import { setDeviceCoordinate as _setDeviceCoordinate } from '../commonActions/setDeviceCoordinate/index.js';
import { setDeviceAnalogAarm as _setDeviceAnalogAarm } from '../commonActions/setDeviceAnalogAarm/index.js';
import { showDevicePlan } from '../commonActions/plan';
import { syncGdSensorConfig, setTimeServer } from '@/api/devices';

import { showCustomLibaryDialog } from '../fcbr100cfr-actions/custom-libary/index.js';
import { showSelfCleanDialog } from '../fcbr100cfr-actions/self-cleaning/index.js';

import { selfCalibration as _selfCalibration } from '@/api/devices';
import { showSelfCalibration } from '../fcbr100cfr-actions/self-calibration';
import { showSendDataIntervalSetting } from '../fcbr100cfr-actions/set-data-interval';

import { show611AlarmThresholdPanel } from '../611-actions/611AlarmThresholdSettings/index.js';

import { openMN606SensorsAlarmThresholdDialog } from '../mn606-actions/setMN606SensorsAlarmThreshold/index.js';

import { updateHt300DeviceInfoDialog } from '../ht300-actions/device-info/index';
import { showMatterInfoDialog } from '../ht300-actions/matter/matter';
export * from '../gd606-action/materials-database/index';

export function toHisWarn(vm) {
  vm.$router.push({ name: 'hisWarn', params: { sn: vm.sn, deviceType: vm.deviceType } });
}

export function modifyParam(vm) {
  vm.paramVisible = true;
}

export function analysisModel(vm) {
  vm.modelVisible = true;
  vm.$nextTick(() => {
    vm.mapLoading = vm.$loading({
      lock: true,
      text: '绘制模型中',
      target: '.model-map',
      background: '#0c162080'
    });
  });
}

export function testingRecord(vm) {
  vm.$router.push({ name: 'CheckList', params: { sn: vm.sn } });
}

export function toExpert(vm) {
  vm.$router.push({ name: 'Expert', params: { sn: vm.sn, deviceType: vm.deviceType } });
}

export function toFaultRecord(vm) {
  vm.$router.push({ name: 'faultRecord', params: { sn: vm.sn, deviceType: vm.deviceType } });
}

export function toHisData(vm) {
  vm.$router.push({ name: 'HisData', params: { sn: vm.sn } });
}

export function toHisData2(vm) {
  vm.$router.push({ name: 'HisData2', params: { sn: vm.sn, deviceType: vm.deviceType } });
}

export function mulMonitor(vm) {
  vm.$router.push({ name: 'MulDevices', params: { deviceType: vm.deviceType } });
}

export function bgroundState(vm) {
  vm.bgStateVisible = true;
}

const optional = {
  hisWarn: ['历史报警', toHisWarn],
  modifyParam: ['参数调整', modifyParam],
  analysisModel: ['分析模型', analysisModel],
  testingRecord: ['检测记录', testingRecord],
  expert: ['专家模式', toExpert],
  hisData: ['历史数据', toHisData],
  mulMonitor: ['多台监控', mulMonitor]
};

export function use(fns, codes) {
  return fns.split(',').forEach((k, i) => {
    const [title, fn] = optional[k];
    return { title, clickFunc: fn, codes: codes[i] };
  });
}

export function musicboxSetting(vm) {
  setting({ sn: vm.sn, deviceType: vm.deviceType });
}

export function musicboxSysStatus(vm) {
  sysStatus({ sn: vm.sn, deviceType: vm.deviceType });
}

export function makeBC500SysStatus(vm) {
  bc500SysStatus({ sn: vm.sn, deviceType: vm.deviceType });
}

export function makeBC500Setting(vm) {
  bc500Setting({ sn: vm.sn, deviceType: vm.deviceType });
}

export function popRG05Setting(vm) {
  rg05Setting({ sn: vm.sn, deviceType: vm.deviceType });
}

export function popRG05NuclideSetting(vm) {
  rg05NuclideSetting({ sn: vm.sn, deviceType: vm.deviceType });
}

export function toSampleRecord(vm) {
  vm.$router.push({ name: 'sampleRecord', params: { sn: vm.sn, deviceType: vm.deviceType } });
}

export function openDocument(deviceType) {
  const docDict = {
    fcbr100Pro: '/static/pdf/FCBR-100PRO-预案.pdf'
  };
  window.open(docDict[deviceType], `${deviceType}_doc`);
}

export function setDeviceCoordinate(vm) {
  _setDeviceCoordinate({ container: vm.$el });
}

export function setDeviceAnalogAarm(vm) {
  _setDeviceAnalogAarm({ container: vm.$el, sn: vm.sn, deviceType: vm.deviceType });
}

export function openDevicePlan(vm) {
  showDevicePlan({ sn: vm.sn, deviceType: vm.deviceType });
}

export function syncGdSensorInfo(vm) {
  vm.$confirm(vm.translateTo('确认同步'))
    .then(e => {
      if (e === 'confirm') {
        syncGdSensorConfig(vm.sn);
      }
    })
    .catch(err => {
      console.log(err);
    });
}

export function selfCleaning(vm) {
  showSelfCleanDialog({ container: vm.$el, sn: vm.sn });
}

export async function selfCalibration(vm) {
  showSelfCalibration({ container: vm.$el, sn: vm.sn });
}

export async function setSendDataInterval(vm) {
  showSendDataIntervalSetting({ container: vm.$el, sn: vm.sn });
}

export function customLibrary(vm) {
  showCustomLibaryDialog({ container: vm.$el, sn: vm.sn });
}

export function set611AlarmThreshold(vm) {
  show611AlarmThresholdPanel({ container: vm.$el, sn: vm.sn });
}

export function setTime(vm) {
  let obj = {
    sn: vm.sn,
    deviceType: vm.deviceType,
    currTime: new Date().getTime()
  };

  setTimeServer(obj).then(res => {
    if (res.code == 200) {
      vm.$message.success('同步成功');
    }
  });
  //   console.log('obj', obj);
  // vm.$router.push({ name: 'hisWarn', params: { sn: vm.sn, deviceType: vm.deviceType } });
}

export function setMN606SensorAlarmThreshold(vm) {
  openMN606SensorsAlarmThresholdDialog({ container: vm.$el, sn: vm.sn });
}

export function updateHt300DeviceInfo(vm) {
  updateHt300DeviceInfoDialog({ container: vm.$el, sn: vm.sn });
}

export function ht300ReadMatterHandle(vm) {
  showMatterInfoDialog({ container: vm.$el, sn: vm.sn });
}
